"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainMenu = void 0;
const zimporter_phaser_1 = require("zimporter-phaser");
const GlobalData_1 = require("./GlobalData");
const LoadingBar_1 = require("./LoadingBar");
const StoryLoader_1 = require("./StoryLoader");
class MainMenu {
    constructor(phaserScene, onPlay, onAbout, onLangChange) {
        this.phaserScene = phaserScene;
        this.onPlay = onPlay;
        this.onAbout = onAbout;
        this.onLangChange = onLangChange;
        this.scene = new zimporter_phaser_1.ZScene('mainMenu', phaserScene);
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            const bar = new LoadingBar_1.LoadingBar(this.phaserScene);
            yield new Promise(resolve => {
                this.scene.load(`${GlobalData_1.GlobalData.assetsBasePath}mainMenu/`, () => {
                    bar.remove();
                    resolve();
                });
            });
            zimporter_phaser_1.ZSceneStack.push(this.scene);
            this.scene.loadStage(this.phaserScene);
            this._applyLabels();
        });
    }
    /** Re-apply labels + re-create overlay after a language switch. */
    reload() {
        return __awaiter(this, void 0, void 0, function* () {
            yield StoryLoader_1.StoryLoader.load(GlobalData_1.GlobalData.currentLang);
            this._applyLabels();
        });
    }
    _applyLabels() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const L = GlobalData_1.GlobalData.labels;
        const ss = this.scene.sceneStage;
        (_a = ss.get('franchiseTitleTXT')) === null || _a === void 0 ? void 0 : _a.setText((_b = L['franchise']) !== null && _b !== void 0 ? _b : '');
        (_c = ss.get('storyNameTXT')) === null || _c === void 0 ? void 0 : _c.setText((_d = L['storyname']) !== null && _d !== void 0 ? _d : '');
        const playBtn = ss.get('playBookBTN');
        (_e = playBtn === null || playBtn === void 0 ? void 0 : playBtn.setLabel) === null || _e === void 0 ? void 0 : _e.call(playBtn, (_f = L['play']) !== null && _f !== void 0 ? _f : 'Play');
        playBtn === null || playBtn === void 0 ? void 0 : playBtn.setCallback(() => { GlobalData_1.GlobalData.playUiSound('MenuButton.mp3'); GlobalData_1.GlobalData.playUiSound('start.mp3'); this.onPlay(); });
        const aboutBtn = ss.get('aboutBTN');
        (_g = aboutBtn === null || aboutBtn === void 0 ? void 0 : aboutBtn.setLabel) === null || _g === void 0 ? void 0 : _g.call(aboutBtn, (_h = L['about']) !== null && _h !== void 0 ? _h : 'About');
        aboutBtn === null || aboutBtn === void 0 ? void 0 : aboutBtn.setCallback(() => { GlobalData_1.GlobalData.playUiSound('MenuButton.mp3'); this.onAbout(); });
        const otherLang = GlobalData_1.GlobalData.currentLang === 'eng' ? 'HEB' : 'ENG';
        const langBTN = ss.get('langBTN');
        (_j = langBTN === null || langBTN === void 0 ? void 0 : langBTN.setVisible) === null || _j === void 0 ? void 0 : _j.call(langBTN, false);
        /*
        langBTN?.setLabel?.(otherLang);
        langBTN?.setCallback(() => {
            const next = GlobalData.currentLang === 'eng' ? 'heb' : 'eng';
            const newLabel = next === 'eng' ? 'HEB' : 'ENG';
            langBTN?.setLabel?.(newLabel);
            this.onLangChange(next);
        });
        */
    }
    destroy() {
        const playBtn = this.scene.sceneStage.get('playBookBTN');
        playBtn === null || playBtn === void 0 ? void 0 : playBtn.removeCallback();
        const aboutBtn = this.scene.sceneStage.get('aboutBTN');
        aboutBtn === null || aboutBtn === void 0 ? void 0 : aboutBtn.removeCallback();
        if (this.scene.sceneStage.parentContainer) {
            this.scene.sceneStage.parentContainer.remove(this.scene.sceneStage);
        }
        this.scene.sceneStage.destroy();
    }
}
exports.MainMenu = MainMenu;
